import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { server } from './global.service';
import { server_ip } from '../../../environments/environment';

var header = {
  Accept: "application/json",
  "Content-Type": "application/json",
}


@Injectable({
  providedIn: 'root'
})


export class staff_service {
  constructor(private backend: server) { }

  staff_list(page,size,mobile):Observable<any> {
    return this.backend.get(server_ip + "/listOfStaff?page="+page+"&size="+size+"&filter="+mobile);
  }
  
  add_staff(data):Observable<any> {
    return this.backend.post(server_ip + "/staffCreation", data, header)
  }
  edit_staff(data):Observable<any> {
    return this.backend.post(server_ip + "/staffEdit", data, header)
  }

  staff_login(data):Observable<any> {
    return this.backend.post(server_ip + "/login_staff", data, header)
  }

  update_staff(data):Observable<any> {
    return this.backend.post(server_ip + "/update_staff", data, header)
  }

  get_roles(userType):Observable<any> {
    return this.backend.get(server_ip + "/get-roles?userType="+userType)
  }

}
